import React from "react";
import { motion } from "motion/react";
import {
  FileText,
  Clock,
  CheckCircle2,
  UserCheck,
  CreditCard,
  DollarSign,
} from "lucide-react";

const PostPaidStatsCards = ({ stats }) => {
  const statCards = [
    {
      title: "Total Requests",
      value: stats.total,
      icon: FileText,
      bgColor: "bg-red-600",
      textColor: "text-red-600",
    },
    {
      title: "Pending",
      value: stats.pending,
      icon: Clock,
      bgColor: "bg-orange-500",
      textColor: "text-orange-600",
    },
    {
      title: "Fully Approved",
      value: stats.approved,
      icon: CheckCircle2,
      bgColor: "bg-green-600",
      textColor: "text-green-600",
    },
    {
      title: "HOD Approved",
      value: stats.hodApproved,
      icon: UserCheck,
      bgColor: "bg-blue-600",
      textColor: "text-blue-600",
    },
    {
      title: "Finance Approved",
      value: stats.financeApproved,
      icon: CreditCard,
      bgColor: "bg-purple-600",
      textColor: "text-purple-600",
    },
    {
      title: "Total Amount",
      value: `GH₵${stats.totalAmount.toFixed(2)}`,
      icon: DollarSign,
      bgColor: "bg-red-600",
      textColor: "text-red-600",
    },
  ];

  return (
    <div className="grid grid-cols-1 gap-6 mb-8 md:grid-cols-2 lg:grid-cols-3">
      {statCards.map((card, index) => {
        const Icon = card.icon;
        return (
          <motion.div
            key={card.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="p-6 bg-white rounded-xl border border-gray-100 shadow-lg transition-shadow duration-300 hover:shadow-xl"
          >
            <div className="flex gap-4 items-center">
              <div className={`p-3 ${card.bgColor} rounded-xl shadow-md`}>
                <Icon className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <p className="text-xs font-medium text-gray-600">
                  {card.title}
                </p>
                <p className="text-3xl font-bold text-gray-900">{card.value}</p>
              </div>
            </div>
          </motion.div>
        );
      })}
    </div>
  );
};

export default PostPaidStatsCards;

